export class ClientDto {
  constructor (clientName, trainingList) {
    this.clientName = clientName
    this.trainingList = trainingList
  }
}



// WEBPACK FOOTER //
// ./src/models/ClientDto.js